import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
// import React from "react";
import Payment from "../components/Checkout/Payment";
import { useLocation} from "react-router-dom";

const Checkout = () => {
  const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

  const location = useLocation();
  // const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const startDate = searchParams.get("start");
  const endDate = searchParams.get("end");

  const isValidDate = (date) => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    return dateRegex.test(date) && !isNaN(new Date(date).getTime());
  };

  console.log("startDate====> ", startDate, isValidDate(startDate));
  console.log("endDate====> ", endDate, isValidDate(endDate));

  // useEffect(() => {
  //   if (!isValidDate(startDate) || !isValidDate(endDate)) {
  //     navigate("/");
  //   }
  // }, [startDate, endDate]);

  return (
    <div>
      <Elements stripe={loadStripe(PUBLISHABLE_KEY)}>
        <Payment startDate={startDate} endDate={endDate} />
      </Elements>
    </div>
  );
};

export default Checkout;
